var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCovidMask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "protect") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38,
    fill: "#0af"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.19,50.85c-6.47,0-7.84-5.76-7.84-12.87s1.37-12.86,7.84-12.86",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.81,25.12c6.47,0,7.84,5.76,7.84,12.86s-1.37,12.87-7.84,12.87",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,51.6a2.89,2.89,0,0,1-.84-1.88V25.88a1.43,1.43,0,0,1,1.1-1.35l6.78-1.4a14.65,14.65,0,0,0,2.14-.65L39,19.29a3.09,3.09,0,0,1,2.08,0l7.75,3.19a14.65,14.65,0,0,0,2.14.65l6.78,1.4a1.43,1.43,0,0,1,1.1,1.35V49.72A2.89,2.89,0,0,1,58,51.6s-9.1,8.17-18,8.17S22,51.6,22,51.6Z",
    fill: "#d1f0ff"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "24.09 31.85 40 29.78 55.91 31.85",
    fill: "none",
    stroke: "#0af",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    strokeDasharray: "4 2.5 6 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.09,46.78A60.68,60.68,0,0,0,40,48.85a60.68,60.68,0,0,0,15.91-2.07",
    fill: "none",
    stroke: "#0af",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    strokeDasharray: "4 2.5 6 2.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.91,
    y1: 40,
    x2: 24.09,
    y2: 40,
    fill: "none",
    stroke: "#0af",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    strokeDasharray: "4 2.5 6 2.5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovidMask);
export default __webpack_public_path__ + "static/media/covid-mask.0e9d1c63.svg";
export { ForwardRef as ReactComponent };